import * as React from 'react'
import { ConnectedRouter } from 'react-router-redux'
import { History } from 'history'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import { ThemeProvider } from './theme/styled'

import defaultTheme from './theme/defaultTheme'
import Layout from './Components/Layout'
import PdAuth from './Components/PdAuth'
import { recordEvent } from './analytics/index'

import './reset.css'
import './App.css'
import { Route } from 'react-router'

type AppProps = {
  history: History
}

/* If the feedback form ends up being a permanent feature, move
   this to Redux state perhaps */
type State = {
  feedbackOpen: boolean
}

class App extends React.Component<AppProps, State> {
  constructor(props: AppProps) {
    super(props)
    this.state = { feedbackOpen: false }
  }

  closeFeedback = () => this.setState({ feedbackOpen: false })

  openFeedback = () => {
    recordEvent('feedback', 'feedback-form-opened')
    this.setState({ feedbackOpen: true })
  }

  render() {
    return (
      <MuiThemeProvider>
        <ThemeProvider theme={defaultTheme}>
          <ConnectedRouter history={this.props.history}>
            <Route
              render={() => (
                <PdAuth>
                  <Layout
                    feedbackOpen={this.state.feedbackOpen}
                    openFeedback={this.openFeedback}
                    closeFeedback={this.closeFeedback}
                  />
                </PdAuth>
              )}
            />
          </ConnectedRouter>
        </ThemeProvider>
      </MuiThemeProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.tsx